var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobility3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
    fill: "#E3147D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59,
    d: "M232.086 138.023L43.5853 113.793L0.214355 158.021C3.20266 214.775 37.7419 263.156 86.6087 286.008L116.561 255.644L232.086 138.023Z",
    fill: "url(#paint0_linear)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.251 96.4075H86.5856C75.6277 96.4075 66.7446 105.291 66.7446 116.248V241.913C66.7446 252.871 75.6277 261.754 86.5856 261.754H212.251C223.208 261.754 232.092 252.871 232.092 241.913V116.248C232.092 105.291 223.208 96.4075 212.251 96.4075Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M252.309 110.034C256.03 113.756 258.12 118.804 258.12 124.067C258.12 129.33 256.03 134.377 252.309 138.099L163.447 137.769H135.371L46.5156 138.099C42.7945 134.377 40.7041 129.33 40.7041 124.067C40.7041 118.804 42.7945 113.756 46.5156 110.034L135.371 21.1904C139.092 17.4697 144.139 15.3794 149.401 15.3794C154.663 15.3794 159.709 17.4697 163.43 21.1904L252.309 110.034Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -12.04,
    y1: 277.026,
    x2: 179.524,
    y2: 85.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobility3);
export default __webpack_public_path__ + "static/media/Mobility 3.76924a70.svg";
export { ForwardRef as ReactComponent };